import {
  RETRIEVE_PAGES,
  GET_PAGE_DETAIL,
  UPDATE_PAGE,
  UPDATE_PAGE_STATUS,
  DELETE_PAGE,
  RESTORE_PAGE,
  CREATE_PAGE,
  GET_PAGE_HEADERS,
  GET_PAGE_SUBHEADERS,
} from "../actions/types";

const initialState = {
  pages: [],
  totalPageCount: 0,
  pageHeaders: [],
  pageSubHeaders: [],
  pageDetails: null,
  createdPage: null,
  updatedPage: null,
};

const pageReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_PAGES:
      return {
        ...state,
        pages: payload.rows,
        totalPageCount: payload.count,
      };

    case GET_PAGE_DETAIL:
      return {
        ...state,
        pageDetails: payload,
      };

    case GET_PAGE_HEADERS:
      return {
        ...state,
        pageHeaders: payload,
      };

    case GET_PAGE_SUBHEADERS:
      return {
        ...state,
        pageSubHeaders: payload,
      };

    case CREATE_PAGE:
      return {
        ...state,
        createdPage: payload,
      };

    case UPDATE_PAGE:
      return {
        ...state,
        updatedPage: payload,
      };

    case UPDATE_PAGE_STATUS:
    case DELETE_PAGE:
    case RESTORE_PAGE:
      return {
        ...state,
        pages: payload.rows,
        totalPageCount: payload.count,
      };

    default:
      return state;
  }
};

export default pageReducer;
